import { WSService } from "../../utils/WSService";

export const serviceSearch = new WSService("/search");
